module.exports = __webpack_public_path__ + "static/media/nowifi.757e220a.svg";